<template>
    <div
        ref="container"
        class="container"
    >
        <slot />
    </div>
</template>

<style lang="scss" scoped>
@use '@design' as *;
</style>
